const { useCallback, useMemo } = require("react");
const { useDispatch } = require("react-redux");
const {
  addAlert,
  updateAlert,
  clearAlerts,
  removeAlert,
} = require("reducers/alertSlice");

function useNotification() {
  const dispatch = useDispatch();

  const notify = useCallback(({ type, title, message, delay = 3, id, ...rest }) => {
    // 🚀 Forwardam orice camp suplimentar (href, onClickStorageKey etc.) - altfel
    // se pierde silentios aici, inainte sa ajunga la Redux/NotificationManager,
    // si un link/actiune adaugata la notificare pare "stricata" fara niciun motiv vizibil.
    dispatch(
      addAlert({
        ...rest,
        type,
        message: title,
        description: message,
        delay,
        id: id ?? Date.now(),
      })
    );
  }, [dispatch]);

  const remove = useCallback((id) => dispatch(removeAlert(id)), [dispatch]);

  const update = useCallback((alert) => dispatch(updateAlert(alert)), [dispatch]);

  const clear = useCallback(() => dispatch(clearAlerts()), [dispatch]);

  return useMemo(
    () => ({ notify, update, clear, remove }),
    [notify, update, clear, remove]
  );
}

export default useNotification;
